import { Check, X } from "lucide-react";
import logoAsset from "@/assets/oz-waste-logo.webp.asset.json";
const logo = logoAsset.url;

const rows = [
  { feature: "We do the heavy lifting", description: "Our team carries it out for you.", skip: "cross" },
  { feature: "No loading the bin yourself", description: "You point, we load.", skip: "cross" },
  { feature: "No bin left at your property", description: "We arrive, load and leave.", skip: "cross" },
  { feature: "Fast photo quoting", description: "Send photos, get your price.", skip: "cross" },
  { feature: "Suitable for bulky furniture", description: "Couches, mattresses and more.", skip: "text", skipText: "Depends / you handle it" },
  { feature: "From a few items to large clear-outs", description: "Only pay for what you need removed.", skip: "text", skipText: "Fixed bin size" },
  { feature: "Personal pickup service", description: "A real team at your door.", skip: "cross" },
] as const;

const ComparisonSection = () => (
  <section id="why-choose-us" className="scroll-mt-28 bg-[#f7f7f7] py-20 md:py-28">
    <div className="container max-w-4xl">
      <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] text-center mb-3 leading-tight">
        <span className="text-orange">OZ WASTE</span> vs Hiring a Skip
      </h2>
      <p className="text-center text-[#1a1a1a]/70 mb-14">
        We do the work so you don't have to.
      </p>

      {/* Table header */}
      <div className="grid grid-cols-[1fr_110px_110px] md:grid-cols-[1fr_160px_140px] items-end gap-0 mb-0">
        <div />
        <div className="bg-gradient-to-b from-[#FDC00E] to-orange rounded-t-2xl py-4 text-center shadow-[0_-4px_16px_rgba(246,74,1,0.22)] flex flex-col items-center justify-center">
          <img src={logo} alt="OZ WASTE CO." className="h-14 md:h-16 w-auto" width="384" height="256" loading="lazy" decoding="async" />
        </div>
        <div className="py-5 text-center">
          <span className="text-[#1a1a1a]/70 font-bold text-xs md:text-sm">
            Traditional
            <br className="md:hidden" /> Skip Bin
          </span>
        </div>
      </div>


      {/* Rows */}
      <div>
        {rows.map((row, i) => (
          <div
            key={row.feature}
            className="grid grid-cols-[1fr_110px_110px] md:grid-cols-[1fr_160px_140px] items-center gap-0 border-b border-[#1a1a1a]/8 last:border-b-0"
          >
            {/* Feature */}
            <div className="py-6 pr-4">
              <p className="font-extrabold text-[#1a1a1a] text-sm md:text-base leading-snug">
                {row.feature}
              </p>
              <p className="text-[#1a1a1a]/70 text-xs md:text-sm mt-1 leading-snug">
                {row.description}
              </p>
            </div>

            {/* OZ WASTE column - yellow */}
            <div
              className={`bg-orange flex items-center justify-center py-6 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.08)] ${
                i === rows.length - 1 ? "rounded-b-2xl shadow-[0_4px_16px_rgba(246,74,1,0.18),inset_0_0_0_1px_rgba(0,0,0,0.08)]" : ""
              }`}
            >
              <div className="w-8 h-8 rounded-full bg-white/25 flex items-center justify-center">
                <Check className="w-4 h-4 text-white" strokeWidth={3} />
              </div>
            </div>

            {/* Traditional skip bin column */}
            <div className="flex items-center justify-center py-6 px-2 text-center">
              {row.skip === "text" ? (
                <span className="text-[#1a1a1a]/45 text-[11px] md:text-xs font-semibold leading-snug">
                  {row.skipText}
                </span>
              ) : (
                <div className="w-8 h-8 rounded-full bg-[#1a1a1a]/[0.04] flex items-center justify-center">
                  <X className="w-4 h-4 text-[#1a1a1a]/20" strokeWidth={2.5} />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default ComparisonSection;
